export interface ParseResult {
  records: Record<string, string>[];
}

export class TextToJsonParserService {
  private static instance: TextToJsonParserService;
  private constructor() {}

  public static getInstance(): TextToJsonParserService {
    if (!TextToJsonParserService.instance) {
      TextToJsonParserService.instance = new TextToJsonParserService();
    }
    return TextToJsonParserService.instance;
  }

  public async parseToJson(textToParse: string): Promise<ParseResult> {
    try {
      const lines = textToParse.split('\n');
      
      // Find table boundaries
      const tableStart = 0
      const tableEnd = lines.length - 1;
      
      // Extract different parts of the text
      const tableLines = lines.slice(tableStart, tableEnd + 1);

      // Process table content
      const records = this.parseTableContent(tableLines);

      return {
        records
      };
    } catch (error) {
      console.error('Error parsing content:', error);
      throw error;
    }
  }


  private parseTableContent(tableLines: string[]): Record<string, string>[] {
    // Get headers from first row and normalize them
    const headers = tableLines[0]
      .split('|')
      .map(column => column.trim())
      .filter(column => column.length > 0)
      .map(this.normaliseColumnName);

    const records: Record<string, string>[] = [];
    
    // Skip header row
    for (let i = 1; i < tableLines.length; i++) {
      const line = tableLines[i].trim();
      if (!line) continue;

      const fields = line
        .split('|')
        .map(field => field.trim());

      const record: Record<string, string> = {};
      headers.forEach((column, index) => {
        record[column] = fields[index];
      });

      records.push(record);
    }

    return records;
  }

  private normaliseColumnName(header: string): string {
    return header.trim();
    // const words = header
    //   .split(/[\s_-]+/)
    //   .filter(word => word.length > 0);

    // return words
    //   .map((word, index) => {
    //     if (index === 0) {
    //       return word.toUpperCase();
    //     }
    //     return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    //   })
    //   .join('');
  }

  public toJsonString(parseResult: ParseResult): string {
    return JSON.stringify(parseResult, null, 2);
  }

  public async textToJsonString(text: string): Promise<string> {
    const result = await this.parseToJson(text);
    return this.toJsonString(result);
  }
}

export const textToJsonParserService = TextToJsonParserService.getInstance();